module.exports = __webpack_public_path__ + "static/media/important-notice.96bb7997.svg";